import 'css-chunksrc/client/pages/searchPage/filters/nameFilter/styles.scss';export default {
  "search": "_search_f7xoj_1"
};